module.exports = __webpack_public_path__ + "static/media/correct_ans.5727b412.png";